module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>\r\n    <input type="text" id="catastrales_titulo" class="form-control" value="'+
((__t=(attributes.catastrales_titulo))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
'/>\r\n</td>\r\n<td>\r\n    <input style="    padding-left: 3px; "   type="text" id="catastrales_referencia" class="form-control" maxlength="20" value="'+
((__t=(attributes.catastrales_referencia))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
'/>\r\n</td>\r\n<td>\r\n    <input type="text" id="catastrales_poligono" class="form-control number"  maxlength="5"   value="'+
((__t=(attributes.catastrales_poligono))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n</td>\r\n<td>\r\n    <input type="text" id="catastrales_parcela" class="form-control number"  maxlength="5"  value="'+
((__t=(attributes.catastrales_parcela))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n</td>\r\n<!--\r\n<td>\r\n        <select id="catastrales_naturaleza" class="form-control" '+
((__t=(disabled))==null?'':_.escape(__t))+
'>\r\n                <option value="">[ -- ]</option>\r\n                ';

                for (var i = 1; i <= 50; i++) {
                        var selected = "";
                        
                        if (attributes.catastrales_naturaleza === 'LNATURALEZACAT_' + i)          
                                selected = "selected";                               
                        if (lang['LNATURALEZACAT_' + i])
                                print('<option value="LNATURALEZACAT_' + i + '" ' + selected + '>' + lang['LNATURALEZACAT_' + i] + '</option>');
                        
                }
                
__p+='\r\n        </select>        \r\n</td>-->\r\n\r\n<td>\r\n    <div class="input-icon input-icon-right">\r\n        <i>€</i>\r\n        <input type="text" placeholder="0,00" id="catastrales_val_suelo" class="form-control money text-right" value="'+
((__t=( attributes.catastrales_val_suelo ))==null?'':_.escape(__t))+
'" '+
((__t=( disabled ))==null?'':_.escape(__t))+
' />\r\n    </div>\r\n</td>\r\n\r\n<td>\r\n    <div class="input-icon input-icon-right">\r\n        <i>€</i>\r\n        <input type="text" placeholder="0,00" id="catastrales_val_cons" class="form-control money text-right" value="'+
((__t=( attributes.catastrales_val_cons ))==null?'':_.escape(__t))+
'" '+
((__t=( disabled ))==null?'':_.escape(__t))+
' />\r\n    </div>\r\n</td>\r\n<td>\r\n    <div class="input-icon input-icon-right">\r\n        <i>€</i>\r\n        <input type="text" placeholder="0,00" id="catastrales_valor" class="form-control money text-right" value="'+
((__t=( attributes.catastrales_valor ))==null?'':_.escape(__t))+
'" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'/>\r\n    </div>\r\n</td>\r\n\r\n<td>\r\n    <div class="input-icon input-icon-right">\r\n        <i>m<sup>2</sup></i>\r\n        <input type="text" placeholder="0,00" id="catastrales_sup_suelo" class="form-control decimal text-right" value="'+
((__t=( attributes.catastrales_sup_suelo ))==null?'':_.escape(__t))+
'" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'/>\r\n    </div>\r\n</td>\r\n<td>\r\n    <div class="input-icon input-icon-right">\r\n        <i>m<sup>2</sup></i>\r\n        <input type="text" placeholder="0,00" id="catastrales_sup_cons" class="form-control decimal text-right" value="'+
((__t=( attributes.catastrales_sup_cons ))==null?'':_.escape(__t))+
'" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'/>\r\n    </div>\r\n</td>\r\n\r\n\r\n\r\n<td>\r\n    <div class="unbreakable"><span class="ion ion-ios-close text-red remove" aria-label="Remove"></span></div>\r\n</td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/goodsDetail/sections/catastrales.ejs
// module id = 155
// module chunks = 0